import React, { useState } from "react";
import { NavLink as Link } from "react-router-dom";
import Logo from "../../images/Avanse-Education-Loans-Logo.png";
import PartnerLogo from "../../images/Partner-Managment.png";

import ApplicationLogo from "../../images/Application.png";
import { DownCircleOutlined, DownOutlined } from "@ant-design/icons";

const PayoutMakerDashboardList = () => {

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  return (
    <div>
      <div className="log-avs">
        <img src={Logo} alt="" />
      </div>
      <div className="list-contnt">
        <ul className="list">
        
          {/* <li className="">
            <Link className="ListItem" to="/CETDashboard/PartnerManagement">
              <img src={PartnerLogo} alt="" className="sidebarIcon" />
              <span className="list-Text"> Partner Management</span>
            </Link>
          </li>

          <li>
            <Link className="ListItem" to="/CETDashboard/AccessManagement">
              <img src={ApplicationLogo} alt="" className="sidebarIcon" />
              <span className="list-Text">Access Management</span>
            </Link>
          </li> */}

          <li className="dropdown1"> 
            
            <Link className="ListItem" onClick={toggleDropdown} style={{color:'#fff'}} to="/PayoutMakerDashBoard/PartnerPayout/generate-report">
             
              <img src={PartnerLogo} alt="" className="sidebarIcon" />
              <span className="list-Text">PARTNER PAYOUT </span>
              <DownOutlined style={{color:'#fff', paddingLeft:"20px" }}/>
             
            </Link> 
            
            {isDropdownOpen && (
              <ul className="dropdown-menu1">
                <li>
                  <Link
                    className="ListItem"
                    to="/PayoutMakerDashBoard/PartnerPayout/generate-report"
                  >
                    <img src={PartnerLogo} alt="" className="sidebarIcon" />
                    <span className="list-Text">Generate Report</span>
                  </Link>
                </li>

                 <li>
                  <Link
                    className="ListItem"
                    to="/PayoutMakerDashBoard/PartnerPayout/generate-report-channelwise"
                  >
                    <img src={PartnerLogo} alt="" className="sidebarIcon" />
                    <span className="list-Text">Channel wise DB report</span>
                  </Link>
                </li>
               
              </ul>
            )}
          </li>

          <li>
            <Link className="ListItem" to="/PayoutMakerDashBoard/PartnerPricing">
              <img src={PartnerLogo} alt="" className="sidebarIcon" />
              <span className="list-Text">Partner Pricing</span>
            </Link>
          </li>

        </ul>
      </div>
    </div>
  );
};

export default PayoutMakerDashboardList;
